const handleDeleteDocumentFileFormActions = {
  confirm: '¿Realmente desea eliminar este archivo?',
  title: 'ELIMINAR ARCHIVO'
};

export default handleDeleteDocumentFileFormActions;
